import { useState } from "react";
import PoseFigure from "./PoseFigure";
import { poseRootLabel, poseRootMeaning } from "./quizUtils";
import styles from "./Quiz.module.css";

function RootsReveal({ pose, rootItems, language }) {
  if (!pose.roots?.length) return null;
  return (
    <div className={styles.rootsReveal}>
      <div className={styles.rootsRevealTitle}>Корни</div>
      {pose.roots.map((r, i) => (
        <div key={`${r.root}-${i}`} className={styles.rootsRevealItem}>
          <span className={styles.rootsRevealSk}>{poseRootLabel(r.root, rootItems, language)}</span>
          <span className={styles.rootsRevealMn}>— {poseRootMeaning(r.root, r.meaning, rootItems, language)}</span>
        </div>
      ))}
    </div>
  );
}

/** Renders one quiz question (either "name" or "picture" type) and reports the result once answered. */
export default function QuizQuestion({ question, onAnswered, rootItems = [], language = "russian" }) {
  const [selected, setSelected] = useState(null);
  const [locked, setLocked] = useState(false);

  if (question.type === "picture") {
    const handlePick = (opt) => {
      if (locked) return;
      setSelected(opt);
      setLocked(true);
      onAnswered(opt.sanskrit === question.answer);
    };

    return (
      <div className={styles.questionWrap}>
        <p className={styles.prompt}>{question.prompt}</p>
        <div className={styles.pictureOptions}>
          {question.options.map((opt) => {
            let cls = styles.pictureOptionBtn;
            if (locked) {
              if (opt.sanskrit === question.answer) cls = styles.pictureOptionCorrect;
              else if (opt.sanskrit === selected?.sanskrit) cls = styles.pictureOptionWrong;
              else cls = styles.pictureOptionDisabled;
            }
            return (
              <button key={opt.sanskrit} type="button" className={cls} onClick={() => handlePick(opt)} disabled={locked}>
                <PoseFigure pose={opt} variant="list" imgClassName={styles.figureImg} wrapClassName={styles.figureImg} />
              </button>
            );
          })}
        </div>
        {locked && <RootsReveal pose={question.pose} rootItems={rootItems} language={language} />}
      </div>
    );
  }

  if (question.type === "root-meaning" || question.type === "root-from-meaning") {
    const handlePick = (opt) => {
      if (locked) return;
      setSelected(opt);
      setLocked(true);
      onAnswered(opt === question.answer);
    };

    return (
      <div className={styles.questionWrap}>
        <p className={styles.prompt}>
          {question.type === "root-meaning" ? "Что означает этот корень?" : "Какой корень означает это?"}
        </p>
        <div className={styles.rootPromptWord}>{question.prompt}</div>
        <div className={styles.options}>
          {question.options.map((opt) => {
            let cls = styles.optionBtn;
            if (locked) {
              if (opt === question.answer) cls = `${styles.optionBtn} ${styles.optionCorrect}`;
              else if (opt === selected) cls = `${styles.optionBtn} ${styles.optionWrong}`;
              else cls = `${styles.optionBtn} ${styles.optionDisabled}`;
            }
            return (
              <button key={opt} type="button" className={cls} onClick={() => handlePick(opt)} disabled={locked}>
                {opt}
              </button>
            );
          })}
        </div>
      </div>
    );
  }

  const handlePick = (opt) => {
    if (locked) return;
    setSelected(opt);
    setLocked(true);
    onAnswered(opt.key === question.answer.key);
  };

  return (
    <div className={styles.questionWrap}>
      <p className={styles.prompt}>Как называется эта асана?</p>
      <div className={styles.figureWrap}>
        <PoseFigure
          pose={question.pose}
          variant="list"
          imgClassName={styles.figureImg}
          wrapClassName={styles.figureImg}
        />
      </div>
      <div className={styles.options}>
        {question.options.map((opt) => {
          let cls = styles.optionBtn;
          if (locked) {
            if (opt.key === question.answer.key) cls = `${styles.optionBtn} ${styles.optionCorrect}`;
            else if (opt.key === selected?.key) cls = `${styles.optionBtn} ${styles.optionWrong}`;
            else cls = `${styles.optionBtn} ${styles.optionDisabled}`;
          }
          return (
            <button key={opt.key} type="button" className={cls} onClick={() => handlePick(opt)} disabled={locked}>
              {opt.label}
            </button>
          );
        })}
      </div>
      {locked && <RootsReveal pose={question.pose} rootItems={rootItems} language={language} />}
    </div>
  );
}
